module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-2200.8db7ca1e.svg";